import { create } from 'zustand';

export type DatasetTemplate = 'file' | 'scratch';

interface DatasetTemplateStore {
  template: DatasetTemplate | undefined;
  setTemplate: (template: DatasetTemplate | undefined) => void;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useDatasetTemplateStore = create<DatasetTemplateStore>((set) => {
  return {
    open: false,
    setOpen: (open: boolean) => set(() => ({ open })),
    template: 'file',
    setTemplate: (template: DatasetTemplate | undefined) =>
      set(() => ({ template })),
  };
});
